define(['text!./templates/ho-upgrade.html'],
    (templateStr)=> {
        let ctrlId = 0;

        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    upgradeExists: '=',
                    upgradeYear: '=',
                    label: '@'
                },
                controller: ['$scope', ($scope)=> {
                    $scope.ctrlId = `HoUpgradeCtrl${ctrlId++}`;
                }]
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/directives/HOUpgrade.js
 **/